import { Component } from "@angular/core";

@Component({
  selector: "app-360-admin",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss", "./reset.scss"]
})
export class AppComponent {
  constructor() {}
}
